var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.isInvalid)?_c('section',[_c('div',{staticClass:"alert",domProps:{"textContent":_vm._s(_vm.$t('error.invalid_address'))}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }